<!--
 * @Author: 半岛铁盒
 * @Date: 2021-11-02 16:48:43
-->
<template>
  <div class="components-container">
    <img class="logo" src="../assets/logo.png" alt="" />
    <div class="menu-content" @click="clickMenuHandle">
      <em class="menu-icon"></em>
      <!-- <span class="font-small">菜单</span> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "comheader",
  data() {
    return {};
  },
  methods: {
    clickMenuHandle() {
      this.$EventBus.$emit("SHOWMENU");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.components-container {
  position: relative;
  widows: 100%;
  height: 100px;
  background-color: #0a0020;
  text-align: center;
  .logo {
    margin-top: 13px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: auto;
    height: 74px;
    z-index: 1;
    cursor: pointer;
  }
  .menu-content {
    margin-left: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    float: left;
    height: 100%;
    em {
      cursor: pointer;
      margin-right: 10px;
      display: block;
      width: 25px;
      height: 25px;
      background: url("../assets/menu.svg") no-repeat;
      background-size: 100% auto;
      background-position: center;
      color: #f4dba0;
    }
    span {
      cursor: pointer;
      font-size: 16px;
      color: #f4dba0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comheader.vue